import React from 'react';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

const sanitizeTip = (tip) => {
  if (tip == null || tip === '') return '';
  if (typeof tip !== 'string') return tip;
  return tip
    .replace(/\(\s*optional\s*[-–—,]?\s*valuation[-\s]?team\s+only\s*\)\.?/gi, '')
    .replace(/\bvaluation[-\s]?team\s+only\.?\s*/gi, '')
    .replace(/\boptional\.?\s*/gi, '')
    .replace(/\(\s*optional\s*\)\.?/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^[\s.\-–—]+|[\s.\-–—]+$/g, '')
    .trim();
};

/**
 * Info icon next to floating outlined label (Aircraft / Engine).
 * Tooltip uses a span child + pointer-events:auto so hover works on InputLabel.
 */
export const FieldInfo = ({ title }) => {
  const tip = sanitizeTip(title);
  if (!tip) return null;
  return (
    <Tooltip
      title={tip}
      arrow
      placement="top"
      enterTouchDelay={0}
      interactive
      PopperProps={{
        disablePortal: false,
        style: { zIndex: 2000 },
      }}
    >
      <span
        className="engine-label-info"
        tabIndex={0}
        role="button"
        aria-label="Field information"
        onClick={(e) => e.preventDefault()}
        onMouseDown={(e) => e.preventDefault()}
      >
        <InfoIcon color="primary" style={{ fontSize: 14 }} />
      </span>
    </Tooltip>
  );
};

/** Floating label: text + required * + optional badge + info icon (right of label) */
export const outlinedLabel = (text, { required = false, tip, badge } = {}) => (
  <span className="engine-outlined-label">
    {text}
    {required ? <span className="engine-req"> *</span> : null}
    {badge ? <span className="engine-internal-badge">{badge}</span> : null}
    {tip ? <FieldInfo title={tip} /> : null}
  </span>
);

export default outlinedLabel;
